module.exports = __webpack_public_path__ + "fonts/3cad8ca484c6d2108ffbc7dc3cb275fd.svg";